(() => {
  class TdAppPlans extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.carousel = this.querySelector('scroll-carousel');
      this.showcase = this.querySelector('.td-app-plans__showcase');
      this.featureTriggers = this.querySelectorAll('[data-feature-trigger]');
      this.overlayIcons = this.querySelectorAll('[data-plan-overlay]');

      if (!this.carousel) return;

      this.#preventImageDrag();

      this.carousel.addEventListener('carousel:change', (event) => {
        this.#setActiveSlide(event.detail.index);
      });

      this.featureTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = Number.parseInt(trigger.dataset.slideIndex, 10);
          if (Number.isNaN(index)) return;
          this.carousel.select(index);
          this.#scrollToShowcase();
        });
      });

      requestAnimationFrame(() => {
        this.#setActiveSlide(this.carousel.selectedIndex || 0);
      });
    }

    #preventImageDrag() {
      this.carousel.addEventListener(
        'mousedown',
        (event) => {
          if (event.button !== 0) return;
          if (event.target.closest('.td-app-plans__slide-media')) {
            event.preventDefault();
          }
        },
        { capture: true }
      );
    }

    #scrollToShowcase() {
      if (!this.showcase || !window.matchMedia('(max-width: 999px)').matches) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.showcase.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    #setActiveSlide(index) {
      this.featureTriggers.forEach((trigger) => {
        const isActive = Number.parseInt(trigger.dataset.slideIndex, 10) === index;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      const slide = this.carousel.cells[index];
      const plan = slide?.dataset.plan;
      if (!plan) return;

      this.overlayIcons.forEach((icon) => {
        icon.hidden = icon.dataset.planOverlay !== plan;
      });
    }
  }

  if (!customElements.get('td-app-plans')) {
    customElements.define('td-app-plans', TdAppPlans);
  }
})();
